import { render, staticRenderFns } from "./predictItem.vue?vue&type=template&id=cbea5eec&scoped=true&"
import script from "./predictItem.vue?vue&type=script&lang=js&"
export * from "./predictItem.vue?vue&type=script&lang=js&"
import style0 from "./predictItem.vue?vue&type=style&index=0&id=cbea5eec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbea5eec",
  null
  
)

export default component.exports